import type {WidgetConfig} from '../../../../form'

export const findWidgetById = (widgets: Array<WidgetConfig>, id: string) => {
  return widgets.find(({widget_id}) => widget_id === id)
}

/**
 * Функция получения массива виджетов по доступным id
 * @param widgets - массив виджетов
 * @param allowedIds - массив widget_id, которые нужно включить или исключить
 * @param isIncluded - фильтровать включая/исключая allowedIds
 */
export const filterWidgetsById = (widgets: Array<WidgetConfig>, allowedIds: string[], isIncluded: boolean = true) => {
  return widgets.filter(widget => {
    if (widget.widget_id) {
      if (isIncluded) return allowedIds.includes(widget.widget_id)
      else return !allowedIds.includes(widget.widget_id)
    }
  })
}
